<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-date-picker
          clearable
          v-model="searchdata"
          type="daterange"
          range-separator="至"
          :value-format="'yyyy-MM-dd'"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary"  icon="el-icon-search" @click="bindGrid()">搜索
        </el-button>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(30)"
      size="mini"
      stripe
      border
      style="width: 100%;">

      <el-table-column
        width="500"
        label=""
        fixed
        align="center"
        header-align="center"
      >
        <el-table-column
          prop="tenantname"
          width="500"
          label="租户名称"
          header-align="center"
          :show-overflow-tooltip="true"
         >
        </el-table-column>

      </el-table-column>
      <el-table-column
        label="基本信息"
        align="left"
        header-align="center"
        width="130"
        prop="fiscalsysguid"
      >
        <el-table-column
          prop="customernumber"
          header-align="center"
          label="门店数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="categorycodenumber"
          header-align="center"
          label="品牌数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="goodsdetailnumber"
          header-align="center"
          label="商品数"
          width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="paraname"
        header-align="center"
        width="300"
        label="销售单">
        <el-table-column
          prop="erpcount"
          header-align="center"
          label="订单数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="totalnumber"
          header-align="center"
          label="商品数"
          width="120">
        </el-table-column>
        <el-table-column
          prop="totalhtje"
          header-align="center"
          label="总销售额"
          width="120">
        </el-table-column>
        <el-table-column
          prop="totalexpressfee"
          header-align="center"
          label="运费"
          width="120">
        </el-table-column>

      </el-table-column>

      <el-table-column label="支付方式" header-align="center">
        <el-table-column
          prop="yuejie"
          header-align="center"
          label="月结"
          width="120">
        </el-table-column>
        <el-table-column
          prop="puhuo"
          header-align="center"
          label="铺货"
          width="120">
        </el-table-column>
        <el-table-column
          prop="wx"
          header-align="center"
          label="微信"
          width="120">
        </el-table-column>
        <el-table-column
          prop="zfb"
          header-align="center"
          label="支付宝"
          width="120">
        </el-table-column>
        <el-table-column
          prop="yue"
          header-align="center"
          label="余额"
          width="120">
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="qita"
          label="其它"
          width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column label="充值" header-align="center">
        <el-table-column
          prop="wxcharge"
          header-align="center"
          label="微信"
          width="120">
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="zfbcharge"
          label="支付宝"
          width="120">
        </el-table-column>
        <el-table-column
          prop="sdcharge"
          header-align="center"
          label="手工登记"
          width="120">
        </el-table-column>
        <el-table-column
          prop="yuetuikuan"
          label="退款入余额"
          header-align="center"
          width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column label="优惠券" header-align="center">
        <el-table-column
          prop="province"
          label="微信"
          header-align="center"
          width="120">
        </el-table-column>
        <el-table-column
          prop="city"
          label="支付宝"
          header-align="center"
          width="120">
        </el-table-column>
      </el-table-column>
      <el-table-column label="入账合计" header-align="center">
        <el-table-column
          prop="wxtotalaccount"
          header-align="center"
          label="微信"
          width="120">
        </el-table-column>
        <el-table-column
          prop="zfbtotalaccount"
          header-align="center"
          label="支付宝"
          width="120">
        </el-table-column>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
  import {runDataList} from '@/api/sysmanage/sysmanage';

  export default {
    name: "RunDataList",
    data() {
      return {
        searchdata: [],//时间段
        tableData:[],
      }
    },
    methods: {
      bindGrid() {
        runDataList({
          startdate:this.searchdata!=undefined&&this.searchdata.length>0?this.searchdata[0]:'',
          enddate:this.searchdata!=undefined&&this.searchdata.length>0&&this.searchdata!=undefined?this.searchdata[1]:'',
        }).then(response => {
          this.tableData = response.data.obj
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      this.bindGrid();
    }, components: {}

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sysmanage/rundata/RunDataList.vue